// import Tables from 'src/class/Tables';
// import i18n from 'src/i18n';

// const configTable = () => {
//   const Table = { ...Tables.Table };
//   Table.tableColumns = [
//     {
//       prop: 'code',
//       label: i18n.t('common_words.code'),
//       minWidth: 80,
//       sortable: true,
//       align: 'center',
//     },
//     {
//       prop: 'name',
//       label: i18n.t('common_words.name'),
//       minWidth: 90,
//       sortable: true,
//     },
//     {
//       prop: 'sowing_type',
//       label: i18n.t('sowing.sowing_type'),
//       minWidth: 100,
//       sortable: true,
//       formatter: (row) => {
//         return row.sowing_type ? row.sowing_type : i18n.t('common_words.no_assigned')
//       },
//     },
//     {
//       prop: 'seed_type.name',
//       label: i18n.t('sowing.seed_type'),
//       minWidth: 100,
//       sortable: true,

//     },
//     {
//       prop: 'distance',
//       label: i18n.t('common_words.distance'),
//       minWidth: 100,
//       sortable: true,
//       align: 'center',
//       formatter: (row) => {
//         return row.distance ? row.distance : i18n.t('common_words.no_assigned')
//       },
//     },
//     {
//       prop: 'temperature',
//       label: i18n.t('climate.temperature'),
//       minWidth: 100,
//       sortable: true,
//       align: 'center',
//       formatter: (row) => {
//         return row.temperature ? row.temperature : i18n.t('common_words.no_assigned')
//       },
//     },
//   ];

//   const Search = { ...Tables.Search };
//   return { Table, Search };

// };

// export default configTable;
import i18n from 'src/i18n';

const configTable = () => {
  const tableColumns = [
    {
      prop: 'code',
      label: i18n.t('common_words.code'),
      minWidth: 80,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      minWidth: 90,
      sortable: true,
    },
    {
      prop: 'type',
      label: i18n.t('sowing.sowing_method'),
      minWidth: 100,
      sortable: true,
      show: false,
      formatter: (row) => {
        return row.type
          ? type
          : i18n.t('common_words.no_assigned')
      },
    },
    {
      prop: 'sowing_type',
      label: i18n.t('sowing.sowing_type'),
      minWidth: 100,
      sortable: true,
      formatter: (row) => {
        return row.sowing_type
          ? row.sowing_type
          : i18n.t('common_words.no_assigned')
      },
    },
    {
      prop: 'seed_type.name',
      label: i18n.t('sowing.seed_type'),
      minWidth: 100,
      sortable: true,

    },
    {
      prop: 'distance',
      label: i18n.t('common_words.distance'),
      minWidth: 100,
      sortable: true,
      align: 'center',
      formatter: (row) => {
        return row.distance
          ? row.distance
          : i18n.t('common_words.no_assigned')
      },
    },
    {
      prop: 'temperature',
      label: i18n.t('climate.temperature'),
      minWidth: 100,
      sortable: true,
      align: 'center',
      formatter: (row) => {
        return row.temperature
          ?
          row.temperature
          : i18n.t('common_words.no_assigned')
      },
    },
    {
      prop: 'description',
      label: i18n.t('common_words.description'),
      minWidth: 100,
      sortable: true,
      align: 'center',
      show: false,
      formatter: (row) => {
        return row.description
          ?
          row.temperature
          : i18n.t('common_words.no_assigned')
      },
    },
  ];
  return { tableColumns };
};

export default configTable;